import React from "react"
import ReCAPTCHA from "react-google-recaptcha"

interface Props {
  children: any
  disabled?: boolean
}

interface ReCaptchaData {
  disabled?: boolean
  token?: string
}

const ReCaptchaContext = React.createContext<ReCaptchaData>({
  disabled: false,
})

const ReCaptchaControl = ({ children, disabled }: Props) => {
  const [token, setToken] = React.useState<string>()

  return (
    <ReCaptchaContext.Provider
      value={{
        disabled,
        token,
      }}
    >
      {!disabled && (
        <div className="my-2">
          <ReCAPTCHA
            sitekey={process.env.GOOGLE_RECAPTCHA_PUBLIC_KEY ?? ""}
            onChange={(x) => setToken(x ?? undefined)}
          />
        </div>
      )}
      {children}
    </ReCaptchaContext.Provider>
  )
}

export default ReCaptchaControl

type RecaptchaCallback = () => RecaptchaValidationResult

interface RecaptchaValidationResult {
  disabled: boolean
  completed: boolean
  valid: boolean
  token?: string
}

interface RecaptchaValidationData {
  execute: RecaptchaCallback
}

export const useRecaptchaValidation = (): RecaptchaValidationData => {
  const { disabled, token } = React.useContext(ReCaptchaContext)

  const execute = () => {
    if (disabled) {
      return {
        completed: false,
        disabled: true,
        valid: true,
      }
    }

    if (!token) {
      return {
        disabled: false,
        completed: false,
        valid: false,
        token,
      }
    }

    return {
      disabled: false,
      completed: true,
      valid: true,
      token,
    }
  }

  return {
    execute,
  }
}
